/**
 * Helpers for the OAuth callback page.
 */

/** Reject values that could navigate away from the current origin. */
export function isSafeReturnPath(url: string): boolean {
  return url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/\\');
}
